import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

const styles = {
  root: {
    width: 760,
    maxWidth: '90%',
    margin: '0 auto',
  },
}

const OnboardingStepContainer = ({ classes, children }) => (
  <div className={classes.root}>
    { children }
  </div>
)

OnboardingStepContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.any,
}

export default withStyles(styles)(OnboardingStepContainer)
